module.exports = __webpack_public_path__ + "media/images/icons/placement_in_bank-124b4c18e3a25872dafccb3af31f532b.svg";